import ViewController from '@af-modules/databinding/prototypes/ViewController';
import AppDrawer from '../modules/AppDrawer';

const AppPageHead = {

    openDrawer() {
        AppDrawer.isOpen = true;
    },

    __proto__: ViewController,
};

export default AppPageHead;



//////////////////
// WEBPACK FOOTER
// ./modules/AppPageHead.js
// module id = 24
// module chunks = 0